/* eslint-disable object-shorthand */
/* eslint-disable no-undef */

// ViteJS glob import all Modules and UIs
const module_chunks = import.meta.glob('./modules/**/index.js');
const ui_chunks = import.meta.glob('./ui/**/index.js');

import domready from "domready";

import "@core/hello";
//import "@core/power-mode";
import windmill from "@core/windmill";
//import WindmillButtons from "@core/windmill.buttons";
//import WindmillCutter from "@core/windmill.cutter";
import WindmillFluidTypography from "@core/windmill.fluid-typography";
import WindmillImgLazyload from "@core/windmill.img-lazyload";
import WindmillPictureColorScheme from "@core/windmill.picture-color-scheme";
import WindmillPrefetch from "@core/windmill.prefetch";
import WindmillRive from "@core/windmill.rive";
import WindmillScripts from "@core/windmill.scripts";
import WindmillScroll from "@core/windmill.scroll";
import WindmillSplitting from "@core/windmill.splitting";
import WindmillChunks from "@core/windmill.chunks";
// import WindmillWebpackChunks from "@core/windmill.webpack-chunks";
// import WindmillDomController from "@core/windmill.dom-controller";
import scrollbarWidth from "@core/scrollbar-width";
import { chrome, edge, firefox, safari, ios, iphone, ipad, android } from "@utils/browser";
import { getHTML, getBody } from "@utils/dom";
import "@utils/prefers-color-scheme";
import transitions from "@transitions";

// ONLY FOR WINDMILL WEBPACK CHUNKS : registry of all modules
import Modules from '@modules/index.chunks.js';

// ONLY FOR WINDMILL DOM CONTROLLER : load all UI and modules classes
//import Modules from '@modules/index.dom-controller';
//import UI from '@ui/index.dom-controller'

/*
 * Main app
 */
class App {
  constructor() {
    this.init();
  }

  init() {
    const browsers = [];

    if( chrome() ) browsers.push('chrome');
    if( edge() ) browsers.push('edge');
    if( firefox() ) browsers.push('firefox');
    if( safari() ) browsers.push('safari');
    if( ios() ) browsers.push('ios');
    if( iphone() ) browsers.push('iphone');
    if( ipad() ) browsers.push('ipad');
    if( android() ) browsers.push('android');

    // add browsers classnames on <html> in a single operation
    getHTML().classList.add(...browsers);

    // set scrollbar's width
    getHTML().style.setProperty('--scrollbar-width', `${scrollbarWidth()}px`);

    // install Windmill's plugins
    windmill.use( new WindmillRive() );
    windmill.use( new WindmillPictureColorScheme() );
    windmill.use( new WindmillFluidTypography() );
    windmill.use( new WindmillScripts() );
    windmill.use( new WindmillChunks(Modules, {...module_chunks, ...ui_chunks }) );
    //windmill.use( new WindmillDomController({ modules: Modules, ui: UI }) );
    windmill.use( new WindmillScroll() );
    //windmill.use( new WindmillCutter() );
    //windmill.use( new WindmillButtons() );
    windmill.use( new WindmillSplitting() );
    windmill.use( new WindmillImgLazyload() );
    windmill.use( new WindmillPrefetch() );


    // if you use Windmill's Async mode, please do this:
    //   - uncomment windmill's css from /scss/commons/index.scss
    //   - use SiteAsyncTransition.js instead of SiteTransition.js
    //   - remove {% include 'site-transition.twig' %} from templates/base.twig
    //   - comment "site-transition" from scss/ui/index.scss
    //   - preferably use WindmillDomController plugin over WindmillWebpackChunks because it enable lower waiting before running page transition
    windmill.init({
      debug: process.env.NODE_ENV === "development",
      async: false,
      prevent: (url, el) => {
        // if admin-bar is shown, prevent all windmill page transition
        if ( getBody().classList.contains('admin-bar') ) return true;

        if (
          /.pdf/.test(url.toLowerCase()) ||
          /.jpg/.test(url.toLowerCase()) ||
          /.png/.test(url.toLowerCase()) ||
          /.gif/.test(url.toLowerCase())
        ) {
          return true;
        }

        if (el && el.classList && el.classList.contains("ais-Pagination-link")) return true;
      },
      transitions: transitions,
    });
  }
}

domready(() => {
  // import main styles in dev mode only
  if (process.env.NODE_ENV === "development") {
    import("../scss/App.scss").then(() => {
      // register @blossom-carousel/web only once our styles are applied,
      // since it reads getComputedStyle(scrollSnapType) synchronously on connect
      import("@blossom-carousel/web").then(() => {
        setTimeout(() => {
          new App();
          import("./GridViewer");
          import("./FPSTracker");
        }, 500);
      });
    });
  } else {
    import("@blossom-carousel/web").then(() => new App());
  }
});
